export const useAccessibility = () => {
  const fontFamily = useCookie<string>('a11y-font', { default: () => 'system' })
  const textColor = useCookie<string>('a11y-text-color', { default: () => 'default' })
  const bgColor = useCookie<string>('a11y-bg-color', { default: () => 'default' })
  const textSize = useCookie<string>('a11y-text-size', { default: () => 'medium' })

  const fontOptions = [
    { value: 'system', label: 'Font Standard' },
    { value: 'serif', label: 'Font Serif' },
    { value: 'mono', label: 'Font Monospaced' },
    { value: 'dyslexic', label: 'Font Dyslexic-Friendly' }
  ]

  const textColorOptions = [
    { value: 'default', label: 'Culoare Text Implicită' },
    { value: 'high-contrast', label: 'Contrast Înalt (Negru pe Alb)' },
    { value: 'inverted', label: 'Inversat (Alb pe Negru)' },
    { value: 'warm', label: 'Tonuri Calde' }
  ]

  const bgColorOptions = [
    { value: 'default', label: 'Fundal Implicit' },
    { value: 'light', label: 'Fundal Deschis' },
    { value: 'dark', label: 'Fundal Întunecat' },
    { value: 'beige', label: 'Fundal Bej (Reduced Glare)' }
  ]

  const textSizeOptions = [
    { value: 'small', label: 'Text Mic' },
    { value: 'medium', label: 'Text Mediu' },
    { value: 'large', label: 'Text Mare' },
    { value: 'xlarge', label: 'Text Foarte Mare' }
  ]

  const applyAccessibilitySettings = () => {
    if (import.meta.client) {
      const root = document.documentElement
      
      root.setAttribute('data-a11y-font', fontFamily.value)
      root.setAttribute('data-a11y-text-color', textColor.value)
      root.setAttribute('data-a11y-bg-color', bgColor.value)
      root.setAttribute('data-a11y-text-size', textSize.value)
    }
  }

  const setFont = (value: string) => {
    fontFamily.value = value
    applyAccessibilitySettings()
  }

  const setTextColor = (value: string) => {
    textColor.value = value
    applyAccessibilitySettings()
  }

  const setBgColor = (value: string) => {
    bgColor.value = value
    applyAccessibilitySettings()
  }

  const setTextSize = (value: string) => {
    textSize.value = value
    applyAccessibilitySettings()
  }

  const resetSettings = () => {
    fontFamily.value = 'system'
    textColor.value = 'default'
    bgColor.value = 'default'
    textSize.value = 'medium'
    applyAccessibilitySettings()
  }

  return {
    fontFamily,
    textColor,
    bgColor,
    textSize,
    fontOptions,
    textColorOptions,
    bgColorOptions,
    textSizeOptions,
    setFont,
    setTextColor,
    setBgColor,
    setTextSize,
    resetSettings,
    applyAccessibilitySettings
  }
}